import { usePageActivityTracker } from '../hooks/usePageActivityTracker';

const PageActivityTracker = () => {
  usePageActivityTracker();
  return null;
};

export default PageActivityTracker;
